import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg.attrs((props) => ({
  color: props.color || '#222',
}))`
  path {
    fill: ${(props) => props.color};
  }
`;

const Delete = ({ width, color }) => {
  return (
    <SVG width={width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
      <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
    </SVG>
  );
};

export default Delete;
